import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Flip } from "gsap/Flip";
import { ScrollToPlugin } from "gsap/all";
import * as d3 from "d3";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(Flip);
gsap.registerPlugin(ScrollToPlugin);

let panels = gsap.utils.toArray(".wp-block-ds-report-section");
const nav = document.querySelector(".report-nav");
const navToggle = document.querySelector(".report-nav-header");

const navTl = gsap.timeline({ paused: true });
navTl.to(".report-nav li", {
  duration: 0.1,
  stagger: 0.05,
  opacity: 1,
  onComplete: () => {
    nav.classList.add("activate-links");
  },
  onReverseComplete: () => {
    nav.classList.remove("activate-links");
  },
});

if (nav) {
  navToggle.addEventListener("pointerdown", (event) => {
    if (navToggle.getAttribute("aria-expanded") === "false") {
      doFlip();
      navTl.play();
    } else {
      doFlip();
      navTl.reverse();
    }
  });

  // close nav when window scrolls
  window.addEventListener("scroll", () => {
    if (navToggle.getAttribute("aria-expanded") === "true") {
      doFlip();
      navTl.reverse();
    }
  });

  // add listener on window, if click outside of open nav, close it
  window.addEventListener("click", (event) => {
    if (
      navToggle.getAttribute("aria-expanded") === "true" &&
      !nav.contains(event.target)
    ) {
      doFlip();
      navTl.reverse();
    }
  });

  window.addEventListener("load", () => {
    let urlHash = window.location.href.split("#")[1],
      scrollElem = document.querySelector("#" + urlHash);
    if (scrollElem) {
      gsap.to(window, { behavior: "instant", scrollTo: scrollElem });
    }
  });

  const navLinks = nav.querySelectorAll("a[href]");
  navLinks.forEach((a, index) => {
    if (index == navLinks.length - 1) return; // link to homepage excluded
    a.addEventListener("click", (e) => {
      e.preventDefault();
      if (e.target.getAttribute("href")) {
        gsap.to(window, {
          duration: 0.5,
          ease: "power4.inOut",
          scrollTo: e.target.getAttribute("href"),
        });
      }
    });
  });
}

function doFlip() {
  const state = Flip.getState(nav);
  nav.classList.toggle("show-all");
  // navHeader.innerHTML = "Table of Contents";
  const expanded = navToggle.getAttribute("aria-expanded");
  navToggle.setAttribute(
    "aria-expanded",
    expanded === "true" ? "false" : "true"
  );
  // navToggle.innerHTML = expanded
  //   ? navToggle.getAttribute("data-title")
  //   : "Table of Contents";

  Flip.from(state, {
    duration: 0.2,
    ease: "power1.inOut",
    nested: true,
  });
}

panels.forEach((panel, i) => {
  if(!nav) return;
  const navChildren = [...nav.querySelectorAll("li")];

  ScrollTrigger.create({
    trigger: panel,
    start: () =>
      panel.offsetHeight < window.innerHeight ? "top top" : "bottom bottom",
    pin: panel.classList.contains('section-no-pin') ? false : true,
    pinSpacing: false,
    // toggleActions: "play none none reverse",
    onLeave: (self) => {
      const index = panels.indexOf(self.trigger);
      navChildren.forEach((child) => {
        child.classList.remove("active");
      });
      navChildren[index + 1].classList.add("active");
      navToggle.setAttribute(
        "data-title",
        navChildren[index + 1].children[0].innerHTML
      );
      navToggle.innerHTML = navChildren[index + 1].children[0].innerHTML;
    },
    onEnterBack: (self) => {
      const index = panels.indexOf(self.trigger);
      navChildren.forEach((child) => {
        child.classList.remove("active");
      });
      navChildren[index].classList.add("active");
      navToggle.setAttribute(
        "data-title",
        navChildren[index].children[0].innerHTML
      );

      navToggle.innerHTML = navChildren[index].children[0].innerHTML;
    },
  });

  const panelHeading = panel.querySelector(".report-section-heading");

  ScrollTrigger.create({
    trigger: panelHeading,
    start: "top+=25% center",
    end: "bottom top",
    toggleClass: { targets: ".report-nav", className: "hide" },
  });
});

// donuts!
// we should maybe only load this file on the impact-report page, or just wrap everything in an if statement
// or maybe separate this into several smaller files
if (document.querySelector("#origin-country-donut-chart")) {
  const width = 1100,
    height = 450,
    margin = 40;
  const radius = Math.min(width, height) / 2 - margin;

  const svg = d3
    .select("#origin-country-donut-chart")
    .append("svg")
    .attr("width", width)
    .attr("height", height)
    .attr("preserveAspectRatio", "xMinYMin meet")
    .attr("viewBox", `0 0 ${width} ${height}`)
    .append("g")
    .attr("transform", `translate(${width / 2},${height / 2})`);

  const data = [
    ["Canada, Iran", 2.9],
    [null, 2.9],
    [null, 2.9],
    ["Vietnam", 2.9],
    [null, 2.9],
    ["Hong Kong", 5.7],
    ["United States", 5.8],
    [null, 2.9],
    ["Brazil", 2.9],
    [null, 2.9],
    [null, 2.9],
    ["India", 11.4],
    ["Nigeria", 5.7],
    ["Canada", 45.7],
  ];

  // set the color scale
  const color = d3.scaleOrdinal([
    "#134842",
    "#068e76",
    "#2fa300",
    "#4e79f1",
    "#9b3e75",
    "#e76604",
    "#c28300",
    "#adfacc",
    "#c2e6ff",
    "#f0fecb",
    "#e3d7fe",
    "#f5f5ed",
    "#ffff6",
    "#3a202d",
  ]);

  // Compute the position of each group on the pie:
  const pie = d3
    .pie()
    .sort(null) // Do not sort group by size
    .value((d) => d[1]);
  const data_ready = pie(data);

  // The arc generator
  const arc = d3
    .arc()
    .innerRadius(radius * 0.5) // This is the size of the donut hole
    .outerRadius(radius * 0.8);

  // Another arc that won't be drawn. Just for labels positioning
  const outerArc = d3
    .arc()
    .innerRadius(radius * 0.9)
    .outerRadius(radius * 0.9);

  // Build the pie chart: Basically, each part of the pie is a path that we build using the arc function.
  svg
    .selectAll("allSlices")
    .data(data_ready)
    .join("path")
    .attr("d", arc)
    .attr("fill", (d) => color(d))
    .attr("stroke", "white")
    .style("stroke-width", "2px")
    .style("opacity", 0.7);
  // Add the polylines between chart and labels:
  svg
    .selectAll("allPolylines")
    .data(data_ready.filter((d) => d.data[0] !== null))
    .join("polyline")
    .attr("stroke", "black")
    .style("fill", "none")
    .attr("stroke-width", 1)
    .attr("points", function (d) {
      const posA = arc.centroid(d); // line insertion in the slice
      const posB = outerArc.centroid(d); // line break: we use the other arc generator that has been built only for that
      const posC = outerArc.centroid(d); // Label position = almost the same as posB
      const midangle = d.startAngle + (d.endAngle - d.startAngle) / 2; // we need the angle to see if the X position will be at the extreme right or extreme left
      posC[0] = radius * 0.95 * (midangle < Math.PI ? 1 : -1); // multiply by 1 or -1 to put it on the right or on the left
      return [posA, posB, posC];
    });

  svg
    .selectAll("allLabels")
    .data(data_ready.filter((d) => d.data[0] !== null))
    .join("text")
    .text((d) => d.data[0] + " - " + d.data[1] + "%")
    .attr("font-size", "1.25rem")
    .attr("transform", function (d) {
      const pos = outerArc.centroid(d);
      const midangle = d.startAngle + (d.endAngle - d.startAngle) / 2;
      pos[0] = radius * 0.99 * (midangle < Math.PI ? 1 : -1);
      pos[1] = pos[1] + 4;
      return `translate(${pos})`;
    })
    .style("text-anchor", function (d) {
      const midangle = d.startAngle + (d.endAngle - d.startAngle) / 2;
      return midangle < Math.PI ? "start" : "end";
    });
}

if (document.querySelector("#ethnicity-donut-chart")) {
  const width = 1100,
    height = 450,
    margin = 40;
  const radius = Math.min(width, height) / 2 - margin;

  const svg = d3
    .select("#ethnicity-donut-chart")
    .append("svg")
    .attr("width", width)
    .attr("height", height)
    .attr("preserveAspectRatio", "xMinYMin meet")
    .attr("viewBox", `0 0 ${width} ${height}`)
    .append("g")
    .attr("transform", `translate(${width / 2},${height / 2})`);

  const data = [
    ["East Asian", 2.9],
    ["Multiracial/biracial", 11.4],
    ["Middle Eastern or North African", 2.9],
    ["Southeast Asian", 8.6],
    ["Hispanic or Latinx", 2.9],
    ["White", 37.1],
    ["Black", 14.3],
    ["South Asian", 20],
  ];

  // set the color scale
  const color = d3.scaleOrdinal([
    "#134842",
    "#068e76",
    "#2fa300",
    "#4e79f1",
    "#9b3e75",
    "#e76604",
    "#c28300",
    "#adfacc",
    "#c2e6ff",
    "#f0fecb",
    "#e3d7fe",
    "#f5f5ed",
    "#ffff6",
    "#3a202d",
  ]);

  // Compute the position of each group on the pie:
  const pie = d3
    .pie()
    .sort(null) // Do not sort group by size
    .value((d) => d[1]);
  const data_ready = pie(data);

  // The arc generator
  const arc = d3
    .arc()
    .innerRadius(radius * 0.5) // This is the size of the donut hole
    .outerRadius(radius * 0.8);

  // Another arc that won't be drawn. Just for labels positioning
  const outerArc = d3
    .arc()
    .innerRadius(radius * 0.9)
    .outerRadius(radius * 0.9);

  // Build the pie chart: Basically, each part of the pie is a path that we build using the arc function.
  svg
    .selectAll("allSlices")
    .data(data_ready)
    .join("path")
    .attr("d", arc)
    .attr("fill", (d) => color(d))
    .attr("stroke", "white")
    .style("stroke-width", "2px")
    .style("opacity", 0.7);

  // Add the polylines between chart and labels:
  svg
    .selectAll("allPolylines")
    .data(data_ready)
    .join("polyline")
    .attr("stroke", "black")
    .style("fill", "none")
    .attr("stroke-width", 1)
    .attr("points", function (d) {
      const posA = arc.centroid(d); // line insertion in the slice
      const posB = outerArc.centroid(d); // line break: we use the other arc generator that has been built only for that
      const posC = outerArc.centroid(d); // Label position = almost the same as posB
      const midangle = d.startAngle + (d.endAngle - d.startAngle) / 2; // we need the angle to see if the X position will be at the extreme right or extreme left
      posC[0] = radius * 0.95 * (midangle < Math.PI ? 1 : -1); // multiply by 1 or -1 to put it on the right or on the left
      return [posA, posB, posC];
    });

  // Add the polylines between chart and labels:
  svg
    .selectAll("allLabels")
    .data(data_ready)
    .join("text")
    .text((d) => d.data[0] + " - " + d.data[1] + "%")
    .attr("font-size", "1.25rem")
    .attr("transform", function (d) {
      const pos = outerArc.centroid(d);
      const midangle = d.startAngle + (d.endAngle - d.startAngle) / 2;
      pos[0] = radius * 0.99 * (midangle < Math.PI ? 1 : -1);
      pos[1] = pos[1] + 4;
      return `translate(${pos})`;
    })
    .style("text-anchor", function (d) {
      const midangle = d.startAngle + (d.endAngle - d.startAngle) / 2;
      return midangle < Math.PI ? "start" : "end";
    });
}

if (document.querySelector("#gender-donut-chart")) {
  const width = 1100,
    height = 450,
    margin = 40;
  const radius = Math.min(width, height) / 2 - margin;

  const svg = d3
    .select("#gender-donut-chart")
    .append("svg")
    .attr("width", width)
    .attr("height", height)
    .attr("preserveAspectRatio", "xMinYMin meet")
    .attr("viewBox", `0 0 ${width} ${height}`)
    .append("g")
    .attr("transform", `translate(${width / 2},${height / 2})`);

  const data = [
    ["Man", 17.1],
    ["Non-Binary", 2.9],
    ["Woman", 80],
  ];

  // set the color scale
  const color = d3.scaleOrdinal([
    "#068e76",
    "#2fa300",
    "#4e79f1",
    "#9b3e75",
    "#e76604",
    "#c28300",
    "#adfacc",
    "#c2e6ff",
  ]);

  // Compute the position of each group on the pie:
  const pie = d3
    .pie()
    .sort(null) // Do not sort group by size
    .value((d) => d[1]);
  const data_ready = pie(data);

  // The arc generator
  const arc = d3
    .arc()
    .innerRadius(radius * 0.5) // This is the size of the donut hole
    .outerRadius(radius * 0.8);

  // Another arc that won't be drawn. Just for labels positioning
  const outerArc = d3
    .arc()
    .innerRadius(radius * 0.9)
    .outerRadius(radius * 0.9);

  // Build the pie chart: Basically, each part of the pie is a path that we build using the arc function.
  svg
    .selectAll("allSlices")
    .data(data_ready)
    .join("path")
    .attr("d", arc)
    .attr("fill", (d) => color(d))
    .attr("stroke", "white")
    .style("stroke-width", "2px")
    .style("opacity", 0.7);

  // Add the polylines between chart and labels:
  svg
    .selectAll("allPolylines")
    .data(data_ready)
    .join("polyline")
    .attr("stroke", "black")
    .style("fill", "none")
    .attr("stroke-width", 1)
    .attr("points", function (d) {
      const posA = arc.centroid(d); // line insertion in the slice
      const posB = outerArc.centroid(d); // line break: we use the other arc generator that has been built only for that
      const posC = outerArc.centroid(d); // Label position = almost the same as posB
      const midangle = d.startAngle + (d.endAngle - d.startAngle) / 2; // we need the angle to see if the X position will be at the extreme right or extreme left
      posC[0] = radius * 0.95 * (midangle < Math.PI ? 1 : -1); // multiply by 1 or -1 to put it on the right or on the left
      return [posA, posB, posC];
    });

  // Add the polylines between chart and labels:
  svg
    .selectAll("allLabels")
    .data(data_ready)
    .join("text")
    .text((d) => d.data[0])
    .attr("font-size", "1.25rem")
    .attr("transform", function (d) {
      const pos = outerArc.centroid(d);
      const midangle = d.startAngle + (d.endAngle - d.startAngle) / 2;
      pos[0] = radius * 0.99 * (midangle < Math.PI ? 1 : -1);
      pos[1] = pos[1] + 4;
      return `translate(${pos})`;
    })
    .style("text-anchor", function (d) {
      const midangle = d.startAngle + (d.endAngle - d.startAngle) / 2;
      return midangle < Math.PI ? "start" : "end";
    });
}

var mapObserver = new IntersectionObserver(function(entries) {
  // isIntersecting is true when element and viewport are overlapping
  // isIntersecting is false when element and viewport don't overlap
  for (var i = 0; i < entries.length; i++) {
    var entry = entries[i];
    if (entry.isIntersecting === true) {
      entry.target.classList.add('active');
      setTimeout(function() {
        entry.target.classList.add('active-pulse');
      }, 2200);
      mapObserver.unobserve(entry.target);
    }
  }
},
{ 
  // threshold: [1]
});
document.querySelectorAll('.impact-map').forEach(function(el) {
  mapObserver.observe(el);
});